export default __webpack_public_path__ + "static/media/clientes12.082ad6b7.png";